<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-primary">
          <form @submit.prevent>
            <div class="box-body">
              <div class="form-group col-md-10">
                <label for="inputName">ID</label>
                <h1 style="margin-top:0px;">
                  <input type="text" :disabled=true class="form-control" id="inputName" placeholder="Court Schedule ID" v-model="formData.id">
                </h1>                        
              </div>
              <div class="form-group col-md-2">
                <!-- <h3 style="margin-top:0px;">
                  <span class="label label-success pull-right">{{ formData.status}}</span>
                </h3>                      -->
              </div>                                 
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="inputSeqNo" class="col-sm-4 control-label">Seq. No.</label>
                    <div class="col-md-8">
                      <input type="text" ref="inputSeqNo" :readonly="viewMode == MODE_VIEW ? true : false" class="form-control" id="inputSeqNo" placeholder="" v-model="formData.seq_no">
                    </div>                     
                  </div>                                         
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="inputScheduleTime" class="col-sm-4 control-label">Time</label>
                    <div class="col-md-8">
                      <input type="text" ref="inputOcccupancy" :readonly="viewMode == MODE_VIEW ? true : false" class="form-control" id="inputScheduleTime" placeholder="" v-model="formData.schedule_time">
                    </div>                     
                  </div>                       
                </div>
              </div>  
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="inputOcccupancy" class="col-sm-4 control-label">Occupancy</label>
                    <div class="col-md-8">
                      <input type="text" @keyup="formattingNumber($event)" ref="inputOcccupancy" :readonly="viewMode == MODE_VIEW ? true : false" class="form-control" id="inputOcccupancy" placeholder="" v-model="formData.occupancy">
                    </div>                     
                  </div> 
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="inputDeletionFlag" class="col-sm-4 control-label">Deletion Flag</label>
                    <div class="col-md-8">
                      <div class="checkbox">
                        <label>
                          <input :disabled="viewMode == MODE_VIEW" type="checkbox" id="inputDeletionFlag" v-model="formData.deletion_flag">
                        </label>
                      </div>
                    </div>                     
                  </div> 
                </div>
              </div> 
              <input type="hidden" class="form-control" v-model="formData.id">                                                                   
              <input type="hidden" class="form-control" v-model="formData.court_id">   
              <input type="hidden" class="form-control" v-model="formData.product_id">   
            </div>

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>                
                <button v-if="viewMode != MODE_VIEW" @click="onCancel()" class="btn btn-warning pull-right">Cancel</button>    
                <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right" style="margin-right:15px;">Save</button>
                
                <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>                            
              </div>
            </div>

          </form>
        </div>          
      </div>
    </div>
  </div>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

const MODE_NONE = 'none'
const MODE_VIEW = 'read'
const MODE_CREATE = 'create'
const MODE_UPDATE = 'update'

export default {
  name: 'CourtScheduleForm',
  components: {
    datepicker
  },
  data() {
    return {
      callback: '',
      DATE_FORMAT: config.dateFormat,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        court_id: '',
        seq_no: '0',
        schedule_time: '',
        occupancy: 0,
        deletion_flag: false,
        product_id: 0
      },
      originalcallback: '',
      prevRoute: null
    }
  },
  computed: {
  },
  created() {
    this.formData.id = this.$route.params.id
    this.formData.court_id = this.$route.params.court_id
    this.formData.occupancy = this.$route.params.court_occupancy
    this.viewMode = this.$route.params.mode
    this.callback = this.$route.params.callback
    this.callbackId = this.$route.params.court_id
    this.originalcallback = this.$route.params.originalcallback

    if (this.viewMode !== MODE_CREATE) {
      this.getDetail()
    }
  },
  mounted() {
  },
  methods: {
    getDetail() {
      api
        .request('Reservation', 'get', '/api/Reservation/Court/Schedule/' + this.formData.id, null)
        .then(response => {
          console.log(response.data.entity)
          this.formData = response.data.entity
        })
        .catch(error => {
          let message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    initForm() {
      this.formData.id = 0
      this.formData.court_id = ''
      this.formData.seq_no = ''
      this.formData.schedule_time = ''
      this.formData.deletion_flag = false
      this.formData.occupancy = 0
      this.formData.product_id = 0
    },
    onEdit(formData) {
      this.viewMode = MODE_UPDATE

      this.formData.id = formData.id
      this.formData.court_id = formData.court_id
      this.formData.seq_no = formData.seq_no
      this.formData.schedule_time = formData.schedule_time
      this.formData.deletion_flag = formData.deletion_flag
      this.formData.occupancy = formData.occupancy
      this.formData.product_id = formData.product_id
    },
    onCancel() {
      if (this.viewMode === MODE_CREATE) {
        this.initForm()
      } else {
        this.getDetail()
      }
    },
    onBack() {
      let params = {
        mode: MODE_VIEW,
        id: this.callbackId,
        callback: this.callback
      }
      this.$router.push({ name: this.callback, params: params })
    },
    onSave() {
      let reqData = {
        id: this.formData.id,
        court_id: this.formData.court_id,
        seq_no: this.formData.seq_no,
        schedule_time: this.formData.schedule_time,
        product_id: this.formData.product_id,
        deletion_flag: this.formData.deletion_flag,
        occupancy: this.formData.occupancy
      }

      let status = 'success'
      let message = ''
      let method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'post'
          break
        case MODE_UPDATE:
          method = 'put'
          break
      }

      api
        .request('Reservation', method, '/api/Reservation/Court/' + this.formData.court_id + '/Schedule', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)

          this.formData.id = response.data.entity.id
          this.getDetail()
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })

      this.viewMode = MODE_VIEW
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// CourtScheduleForm.vue?0be809cd